import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Role} from "../../models/Role"

export const roleFields: IntercateKeysMap<Role, EntityField<Role>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id uloge",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    name: {
		name: "name", dataType: EntityFieldDataType._string, label: "Uloga",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    alias: {
		name: "alias", dataType: EntityFieldDataType._string, label: "Alias",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    permissions: {
		name: "permissions", dataType: EntityFieldDataType._string, label: "Dozvole",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    documentPermissions: {
		name: "documentPermissions", dataType: EntityFieldDataType._string, label: "Dozvole nad dokumentima",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
}

const roleFieldsArray: Array<EntityField<Role>> = [
	roleFields.name,
    roleFields.alias,
	
]

export const roleFieldsDescriptor: EntityFieldsDescriptor<Role> = {
	listFields: roleFieldsArray,
	createFormFields: roleFieldsArray,
	updateFormFields: roleFieldsArray
}